import { capture } from "./capture";

export const ExperimentsTracking = {
  /** Experiment created. */
  created: (name: string, effortLevel: string, entityCount: number, metricCount: number) => {
    capture("experiments.created", {
      name,
      effort_level: effortLevel,
      entity_count: entityCount,
      metric_count: metricCount,
    });
  },
};
